import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Form, Loader, Typography } from 'amphitheatre';
import AnimateHeight from 'react-animate-height';

import {
  ContainerWrapper,
  FormWrapper,
  QOBLogo,
  LogoGIF,
} from './Login.styled';
import { QFBButton } from '../Landing.styled';
import { Props } from './Login.types';
import Logo from './_img_logo.png';
import LogoAnim from './_gif_logo.gif';

import { rawURL } from '../../../index';

const { Header } = Typography;

function Landing({ loading, onLogin }: Props): React.ReactElement {
  const [finished, setFinished] = useState(false);
  const [finishAll, setFinishedAll] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const gifRef = useRef<HTMLImageElement>(null);

  let className: string | undefined = 'anim-in';

  if (finished && !finishAll) {
    className = 'anim-end';
  } else if (finishAll) {
    className = undefined;
  }

  function startAnim() {
    if (gifRef && gifRef.current) {
      gifRef.current.src = LogoAnim;
    }

    setLoaded(true);

    setTimeout(() => {
      setFinished(true);
    }, 1677);

    setTimeout(() => {
      setFinishedAll(true);
    }, 2427);
  }

  useEffect(() => {
    const loadingGif = new Image();
    loadingGif.onload = startAnim;
    loadingGif.src = LogoAnim;
  }, []);

  return (
    <ContainerWrapper>
      <Container className={className} size="xs">
        {finished ? <QOBLogo src={Logo} /> : <LogoGIF ref={gifRef} />}
        {loaded ? null : <Loader message="Loading Assets" />}
        <AnimateHeight delay={250} duration={500} height={finished ? '70%' : 0}>
          <FormWrapper>
            <div style={{ padding: '1rem' }} />
            <Form onSubmit={onLogin}>
              <Header level={5} style={{ fontWeight: 'bold' }}>
                Login with your Saber Account
              </Header>
              <Form.Validator name="username" required>
                <Form.Input label="Username" />
              </Form.Validator>
              <Form.Validator name="password" type="password" required>
                <Form.Input label="Password" />
              </Form.Validator>
              <Form.Validator name="preserveToken">
                <Form.Checkbox label="Stay signed in?" />
              </Form.Validator>
              <Button type="submit" fill loading={loading}>
                Login
              </Button>
            </Form>
            <a
              href={`https://account.${rawURL}/register`}
              style={{ display: 'block', marginTop: '1rem' }}
              rel="noopener noreferrer"
              target="_blank"
            >
              <QFBButton disabled={loading}>Register For An Account</QFBButton>
            </a>
            <Link to="/about" style={{ display: 'block', marginTop: '1rem' }}>
              <Button fill ghost disabled={loading}>
                About Quest For Blue
              </Button>
            </Link>
            <Link to="/faq" style={{ display: 'block', marginTop: '1rem' }}>
              <Button fill ghost disabled={loading}>
                Frequency Asked Questions
              </Button>
            </Link>
          </FormWrapper>
        </AnimateHeight>
      </Container>
    </ContainerWrapper>
  );
}

export default Landing;
